import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingEntityCategory  {
    _originalTypeClassName = "zERP.BO.AccountingEntityCategory";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingEntityCategory.translate = translateService;
}
this.SystemEntity = new Domain.AccountingSystemEntity();
this.Values = [];
this.AvailableFor = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.AllowMultiSelect = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
AllowMultiSelect:any;
SystemEntity:any;
Values:any;
AvailableFor:any;
static setSystemEntity = ($this, value) => {
var oldValue = $this.SystemEntity;
$this.SystemEntity = value;
if (value != null) {
}
}
static setValues = ($this, items) => {
                if (items == null) items = [];
                if ($this.Values == null) $this.Values = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Values.length > 0) {
                    Domain.AccountingEntityCategory.removeValues($this, $this.Values[0]);
                }

                Domain.AccountingEntityCategory.addManyValues($this, copyItems);
            }
static addManyValues = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingEntityCategory.addValues($this, items[i]);
                }
            }
static addValues = ($this, item) => {
                if ($this.Values == null) $this.Values = [];
                if (item == null || $this.Values.indexOf(item) > -1) return;
                $this.Values.push(item);
if (item.Category != $this) {
Domain.AccountingEntityCategoryValue.setCategory(item, $this);
}
}
static addRangeValues = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingEntityCategory.addValues($this, item));
            }
static removeValues = ($this, item) => {
                if ($this == null || $this.Values == null || $this.Values.indexOf(item) === -1) return;
                var _index = $this.Values.indexOf(item);
                $this.Values.splice(_index, 1);
item.Category = null;
}
static clearValues = ($this) => { $this.Values = null; }
static setAvailableFor = ($this, items) => {
                if (items == null) items = [];
                if ($this.AvailableFor == null) $this.AvailableFor = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AvailableFor.length > 0) {
                    Domain.AccountingEntityCategory.removeAvailableFor($this, $this.AvailableFor[0]);
                }

                Domain.AccountingEntityCategory.addManyAvailableFor($this, copyItems);
            }
static addManyAvailableFor = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingEntityCategory.addAvailableFor($this, items[i]);
                }
            }
static addAvailableFor = ($this, item) => {
                if ($this.AvailableFor == null) $this.AvailableFor = [];
                if (item == null || $this.AvailableFor.indexOf(item) > -1) return;
                $this.AvailableFor.push(item);
}
static addRangeAvailableFor = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingEntityCategory.addAvailableFor($this, item));
            }
static removeAvailableFor = ($this, item) => {
                if ($this == null || $this.AvailableFor == null || $this.AvailableFor.indexOf(item) === -1) return;
                var _index = $this.AvailableFor.indexOf(item);
                $this.AvailableFor.splice(_index, 1);
}
static clearAvailableFor = ($this) => { $this.AvailableFor = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}